import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import NavItems2 from "../NavItems2";
import NavItems3 from "../NavItems3";
import "./Modernization1.css";
import "../../styleguide.css";
export let m_allData1 = [];
export let m_yesCount1 = 0;

function Modernization1(props) {
  const [selectedOptions, setSelectedOptions] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const {
    x1200PxLogo_Icam__20081,
    navItems2Props,
    navItems3Props,
  } = props;

  useEffect(() => {
    // Calculate the total number of questions based on sections
    const sections = document.getElementsByTagName("section");
    setTotalQuestions(sections.length);
  }, []); // Run this effect only once when the component mounts

  function clicked(question, option) {
    // Si l'option cliquée est la màªme que celle déjà  sélectionnée, on la désélectionne
    if (selectedOptions[question] === option) {
      setSelectedOptions((prevSelectedOptions) => {
        const newOptions = { ...prevSelectedOptions };
        delete newOptions[question];
        return newOptions;
      });
      // Si on désélectionne un "Yes", on décrémente le score
      if (option === "Yes") {
        m_yesCount1--;
      }
      return;
    }

    // Sinon, on met à  jour la sélection
    const previousOption = selectedOptions[question];
    setSelectedOptions((prevSelectedOptions) => ({
      ...prevSelectedOptions,
      [question]: option,
    }));
    
    // Si on passe de "No" à  "Yes", on incrémente le score
    if (option === "Yes" && previousOption !== "Yes") {
      m_yesCount1++;
    }
    // Si on passe de "Yes" à  "No", on décrémente le score
    else if (option === "No" && previousOption === "Yes") {
      m_yesCount1--;
    }
  }

  const history = useHistory();

  function saveData() {
    setIsLoading(true);
    setErrorMessage("");
    
    console.log("Début de sauvegarde des données Modernization1");
    
    const enterpriseId = localStorage.getItem("enterpriseId");
    const userId = localStorage.getItem("userId");
    
    if (!enterpriseId) {
      console.error("ERREUR: ID d'entreprise manquant");
      setErrorMessage("ID d'entreprise manquant. Veuillez retourner à  la sélection d'entreprise.");
      setIsLoading(false);
      return;
    }

    // Définir toutes les questions possibles
    const allQuestions = [
      "Do you have AI models that can solve problems?",
      "Do you use intelligent agents to solve simulation problems?",
      "Do you have any models for forecasting sales?",
      "Do you have models for sales forecasting?",
      "Do you have models for forecasting purchases?",
      "Do you have robots that can be autonomous on complex tasks?",
      "Do you have a cybersecurity system using AI models?"
    ];

    // Créer un tableau de questions/réponses pour toutes les questions
    const data = allQuestions.map(question => {
      const answer = selectedOptions[question] || "No";
      return {
        question: question,
        answer: answer,
        category: "modernization",
        enterpriseId: enterpriseId,
        userId: userId || "",
        section: "modernization-1",
        timestamp: new Date().toISOString()
      };
    });
    
    // Vérifier que les données sont correctement formatées
    const isValidData = data.every(item => 
      item.question && 
      item.answer && 
      item.category && 
      item.enterpriseId
    );

    if (!isValidData) {
      console.error("Données invalides:", data);
      setErrorMessage("Format de données invalide");
      setIsLoading(false);
      return;
    }
    
    // Sauvegarder les données pour une utilisation ultérieure
    m_allData1 = [...data];
    console.log("Données à  envoyer:", JSON.stringify(data, null, 2));
    
    // Appel API pour sauvegarder les données
    fetch(process.env.REACT_APP_API_URL + "/api/save-answers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : "",
      },
      body: JSON.stringify(data),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Erreur de sauvegarde (${response.status})`);
      }
      return response.json();
    })
    .then(result => {
      console.log("Data saved successfully:", result);
      
      // Sauvegarder le score dans le localStorage
      localStorage.setItem('modernization1Score', m_yesCount1);
      console.log(`Score modernization1 mis à  jour: ${m_yesCount1}`);
      
      setIsLoading(false);
      history.push("/modernization-2");
    })
    .catch(error => {
      console.error("Error saving data:", error);
      setErrorMessage("Error saving data. Please try again.");
      console.error("Détails de l'erreur:", error.message);
      setIsLoading(false);
      history.push("/modernization-2");
    });
  }

  function calculateProgressPercentage() {
    const totalQuestions = document.getElementsByTagName("section").length;
    if (totalQuestions === 0) return 0;
    return Math.round((m_yesCount1 / totalQuestions) * 100);
  }

  return (
    <div className="environmental-container">
      <div className="environmental-content">
        <h1 className="environmental-title">
          PLEASE ANSWER THE FOLLOWING QUESTIONS
        </h1>
        
        <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{width: `${calculateProgressPercentage()}%`}}
            ></div>
          </div>
          <p className="progress-text">
            Your score: {m_yesCount1} / {totalQuestions} ({calculateProgressPercentage()}%)
          </p>
        </div>

        {errorMessage && <p className="error-message">{errorMessage}</p>}

        <div className="questions-container">
          <section className="question-card">
            <p className="question-text">Do you have AI models that can solve problems?</p>
            <div className="question-actions">
              <button 
                onClick={() => clicked("Do you have AI models that can solve problems?", "Yes")} 
                className={`btn-option ${selectedOptions["Do you have AI models that can solve problems?"] === "Yes" ? "enabled" : ""}`}
              >
                Yes
              </button>
              <button 
                onClick={() => clicked("Do you have AI models that can solve problems?", "No")} 
                className={`btn-option ${selectedOptions["Do you have AI models that can solve problems?"] === "No" ? "enabled" : ""}`}
              >
                No
              </button>
            </div>
          </section>

          <section className="question-card">
            <p className="question-text">Do you use intelligent agents to solve simulation problems?</p>
            <div className="question-actions">
              <button 
                onClick={() => clicked("Do you use intelligent agents to solve simulation problems?", "Yes")} 
                className={`btn-option ${selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "Yes" ? "enabled" : ""}`}
              >
                Yes
              </button>
              <button 
                onClick={() => clicked("Do you use intelligent agents to solve simulation problems?", "No")} 
                className={`btn-option ${selectedOptions["Do you use intelligent agents to solve simulation problems?"] === "No" ? "enabled" : ""}`}
              >
                No
              </button>
            </div>
          </section>

          <section className="question-card">
            <p className="question-text">Do you have any models for forecasting sales?</p>
            <div className="question-actions">
              <button 
                onClick={() => clicked("Do you have any models for forecasting sales?", "Yes")} 
                className={`btn-option ${selectedOptions["Do you have any models for forecasting sales?"] === "Yes" ? "enabled" : ""}`}
              >
                Yes
              </button>
              <button 
                onClick={() => clicked("Do you have any models for forecasting sales?", "No")} 
                className={`btn-option ${selectedOptions["Do you have any models for forecasting sales?"] === "No" ? "enabled" : ""}`}
              >
                No
              </button>
            </div>
          </section>

          <section className="question-card">
            <p className="question-text">Do you have models for sales forecasting?</p>
            <div className="question-actions">
              <button 
                onClick={() => clicked("Do you have models for sales forecasting?", "Yes")} 
                className={`btn-option ${selectedOptions["Do you have models for sales forecasting?"] === "Yes" ? "enabled" : ""}`}
              >
                Yes
              </button>
              <button 
                onClick={() => clicked("Do you have models for sales forecasting?", "No")} 
                className={`btn-option ${selectedOptions["Do you have models for sales forecasting?"] === "No" ? "enabled" : ""}`}
              >
                No
              </button>
            </div>
          </section>

          <section className="question-card">
            <p className="question-text">Do you have models for forecasting purchases?</p>
            <div className="question-actions">
              <button 
                onClick={() => clicked("Do you have models for forecasting purchases?", "Yes")} 
                className={`btn-option ${selectedOptions["Do you have models for forecasting purchases?"] === "Yes" ? "enabled" : ""}`}
              >
                Yes
              </button>
              <button 
                onClick={() => clicked("Do you have models for forecasting purchases?", "No")} 
                className={`btn-option ${selectedOptions["Do you have models for forecasting purchases?"] === "No" ? "enabled" : ""}`}
              >
                No
              </button>
            </div>
          </section>

          <section className="question-card">
            <p className="question-text">Do you have robots that can be autonomous on complex tasks?</p>
            <div className="question-actions">
              <button 
                onClick={() => clicked("Do you have robots that can be autonomous on complex tasks?", "Yes")} 
                className={`btn-option ${selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "Yes" ? "enabled" : ""}`}
              >
                Yes
              </button>
              <button 
                onClick={() => clicked("Do you have robots that can be autonomous on complex tasks?", "No")} 
                className={`btn-option ${selectedOptions["Do you have robots that can be autonomous on complex tasks?"] === "No" ? "enabled" : ""}`}
              >
                No
              </button>
            </div>
          </section>

          <section className="question-card">
            <p className="question-text">Do you have a cybersecurity system using AI models?</p>
            <div className="question-actions">
              <button 
                onClick={() => clicked("Do you have a cybersecurity system using AI models?", "Yes")} 
                className={`btn-option ${selectedOptions["Do you have a cybersecurity system using AI models?"] === "Yes" ? "enabled" : ""}`}
              >
                Yes
              </button>
              <button 
                onClick={() => clicked("Do you have a cybersecurity system using AI models?", "No")} 
                className={`btn-option ${selectedOptions["Do you have a cybersecurity system using AI models?"] === "No" ? "enabled" : ""}`}
              >
                No
              </button>
            </div>
          </section>
        </div>

        <div className="form-actions">
          <Link to="/social-6" className="btn-secondary">
            Back
          </Link>
          <button onClick={saveData} className="btn-primary">
            Next
          </button>
        </div>

        {isLoading && (
          <div className="loading-indicator">
            <div className="spinner"></div>
            <p>Saving data...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Modernization1;
